var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconTimeClockActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0001 18.3333C14.6025 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39763 14.6025 1.66667 10.0001 1.66667C5.39771 1.66667 1.66675 5.39763 1.66675 10C1.66675 14.6024 5.39771 18.3333 10.0001 18.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0916 13.275C12.9833 13.275 12.875 13.25 12.775 13.1833L10.1916 11.6417C9.54995 11.2583 9.07495 10.4167 9.07495 9.675V6.25833C9.07495 5.91667 9.35828 5.63333 9.69995 5.63333C10.0416 5.63333 10.325 5.91667 10.325 6.25833V9.675C10.325 9.975 10.575 10.4167 10.8333 10.5667L13.4166 12.1083C13.7166 12.2833 13.8083 12.6667 13.6333 12.9667C13.5083 13.1667 13.3 13.275 13.0916 13.275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconTimeClockActive);
export default __webpack_public_path__ + "static/media/menu_icon_time_clock_active.86f1059752741eb31ed212c813cae537.svg";
export { ForwardRef as ReactComponent };